import { AbstractControl, ValidationErrors } from '@angular/forms';

const EMAIL_REGEX = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;

/**
 * Valida o formato do e-mail.
 * Campo vazio é considerado válido — quem cobra o preenchimento é o Validators.required.
 * A comparação ignora maiúsculas/minúsculas e espaços nas pontas.
 */
export function emailValidator(control: AbstractControl<string>): ValidationErrors | null {
  const email = (control.value ?? '').trim().toLowerCase();

  if (!email) {
    return null;
  }

  return EMAIL_REGEX.test(email) ? null : { email: true };
}
